import { create } from "zustand";
import { Notify } from "@/components/ui/notify";

// Guarda global de navegação (o app usa <BrowserRouter> clássico, sem useBlocker).
// Uma tela com trabalho não salvo REGISTRA um guard `{ when, message }`; a navegação (por comando do
// assistente OU manual) chama `confirmLeave()` antes de sair — mesma confirmação de descarte nos dois
// caminhos (paridade honesta com a navegação manual).

interface GuardState {
  when: (() => boolean) | null;
  message: string;
  setGuard: (when: (() => boolean) | null, message?: string) => void;
}

export const useNavigationGuard = create<GuardState>((set) => ({
  when: null,
  message: "Você tem alterações não salvas. Descartar e sair?",
  setGuard: (when, message) => set((s) => ({ when, message: message ?? s.message })),
}));

/** Confirma a saída se houver guard ativo com trabalho sujo. Retorna true se pode navegar. */
export async function confirmLeave(): Promise<boolean> {
  const { when, message } = useNavigationGuard.getState();
  if (!when || !when()) return true;
  return Notify.confirm({
    variant: "warning",
    title: "Alterações não salvas",
    description: message,
  });
}
